var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "project-delete-confirmation-modal",
        pivotY: 0.2,
        width: "590",
        height: "auto"
      }
    },
    [
      _c("div", { staticClass: "modal-img-container" }, [
        _c("img", {
          staticClass: "modal-img",
          attrs: { src: _vm.titleImageProject(_vm.projectGUID) }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.hideModal("project-delete-confirmation-modal")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-title" }, [
        _vm._v("\n        Удалить проект\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-text" }, [
        _vm._v("\n        Удалить проект"),
        _c("span", { staticClass: "bold-text" }, [
          _vm._v(" " + _vm._s(_vm.nameProject))
        ]),
        _vm._v("?\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-button", on: { click: _vm.deleteProject } },
        [_vm._v("\n        Удалить\n    ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }